import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Desktop } from "./screens/Desktop/Desktop";
 import CarsInfoPageBlock from "./screens/Desktop/VehicleInfoPage/CarsInfoPageBlock";
import CarFormPage from "./screens/Desktop/manualInputCarInfo/CarFormPage";
import RenderProfilePage from "./screens/Desktop/profile/RenderProfilePage";
import PhoneNumberModal from "./screens/Desktop/relogin/PhoneNumberModal";
import VerifyCode from "./screens/Desktop/relogin/VerifyCode";
import {NewsPages} from "./screens/Desktop/news_pages/NewsPages";
import {NewsResultPage} from "./screens/Desktop/news_pages/NewsResultPage";
import PhoneRequestPage from "./screens/Desktop/PhoneRequestPage/PhoneRequestPage";
import {HeroNewOrder} from "./screens/Desktop/sections/HeroNewOrder/HeroNewOrder";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Desktop />} />
                <Route path="/vehicle-info" element={<CarsInfoPageBlock />} />
                <Route path="/manual-info-car" element={<CarFormPage />} />
                <Route path="/profile-page" element={<RenderProfilePage />} />
                <Route path="/phone-number-modal" element={<PhoneNumberModal />} />
                <Route path="/verify-code" element={<VerifyCode />} />
                <Route path="/news-pages" element={<NewsPages />} />
                <Route path="/news-result" element={<NewsResultPage />} />
                <Route path="/phone-request-page" element={<PhoneRequestPage />} />
                <Route path="/new-order" element={<HeroNewOrder />} />

            </Routes>
        </Router>
    );
}

export default App;
